import { HeaderMobile } from './HeaderMobile';
import { HeaderDesktop } from './HeaderDesktop';
import { withWebResponsiveDesign } from '../../../hoc/withWebResponsiveDesign';
import { THeaderProps } from './Header.types';

export const Header = withWebResponsiveDesign<THeaderProps>(HeaderMobile, HeaderDesktop);